import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type InitialStateProps = {
    modal: string,
    animateExit: boolean,
    hoverIcons: number,
    viewportDimensions: [number, number],
    homeScroll: number | null
    settingsScroll: number | null,
    lang: 'en' | 'ma'
};

const initialState: InitialStateProps = {
    modal: '',
    animateExit: false,
    hoverIcons: 0,
    viewportDimensions: [0, 0],
    homeScroll: null,
    settingsScroll: null,
    lang: 'ma'
};

type NumberField = 'homeScroll' | 'settingsScroll';

const displaySlice = createSlice({
    name: 'display',
    initialState,
    reducers: {
        toggleModal: (state, action: PayloadAction<string>) => {
            const {payload} = action
            state.modal = payload ? payload : '';
        },
        triggerModalExit: (state) => {
            state.animateExit = true;
            setTimeout(() => {
                state.animateExit = false;
            }, 0);
        },
        toggleLanguage_display: (state, action: PayloadAction<'en' | 'ma'>) => {
            state.lang = action.payload;
        },
        moveHoverIcons_display: (state, action: PayloadAction<number>) => {
            state.hoverIcons = action.payload;
        },
        setViewportDimensions_display: (state) => {
            state.viewportDimensions = [window.innerWidth, window.innerHeight];
        },
        setNumber_display: (state, action: PayloadAction<{field: NumberField, value: number}>) => {
            const { field, value } = action.payload;
            state[field] = value;
        }
    }
});

export const { 

    toggleModal, 
    triggerModalExit,
    moveHoverIcons_display, 
    toggleLanguage_display, 
    setViewportDimensions_display,
    setNumber_display

} = displaySlice.actions;

export default displaySlice.reducer;